import type { Definition } from '../../../../schema/frameworks/entry.js';
import type { externalWagerApiResponse, ExternalWagerGuid } from '../../../../schema/wager/entry.js';
import { type IGetExternalWagerUseCase, NotFoundError } from '../../../domain/entry.js';

export type IGetExternalWagerController = ReturnType<typeof getExternalWagerController>;

type ExternalWagerResponse = Extract<ReturnType<(typeof externalWagerApiResponse)['parse']>, { data: object }>['data'];

/**
 * Controller to get a external wager.
 *
 * @param getExternalWagerUseCase Use case for getting a external wager
 * @returns Controller function that retrieves wager data
 * @throws {NotFoundError} if the external wager product does not match
 */
export function getExternalWagerController(getExternalWagerUseCase: IGetExternalWagerUseCase) {
  return async function controller(
    externalWagerGuid: ExternalWagerGuid,
    product?: Definition['moduleEngine']
  ): Promise<ExternalWagerResponse> {
    const data = await getExternalWagerUseCase.execute({ externalWagerGuid });

    if (product && data.coupon.product !== product) {
      throw new NotFoundError(
        `External wager with guid ${externalWagerGuid} has product ${data.coupon.product}, which does not match expected product ${product}`
      );
    }

    return data;
  };
}
